import { CountryBoundsResponse } from 'types/api/response/country-bounds-response'

import { api } from './api'

export const getCountryBounds = (countryId: number) =>
  api.get<CountryBoundsResponse>(`/countries/${countryId}/bounds`)
